module.exports = __webpack_public_path__ + "img/dog.0a03e311.jpg";